import type { StateCreator } from "zustand";

import type { UIState } from "./index";

// ---------------------------------------------------------------------------
// Drawer slice — manages which drawer is open (mutually exclusive)
// ---------------------------------------------------------------------------
// ActiveDrawer is a discriminated union. Each variant carries only the data
// needed for that drawer. Only one drawer can be open at a time — calling
// openDrawer() replaces whatever was open.
//
// To add a new drawer:
//   1. Add an ID to DRAWER_ID
//   2. Add a variant to ActiveDrawer
//   3. Use openDrawer({ id: DRAWER_ID.… }) from the consumer
//   4. No changes to the store or slice needed
// ---------------------------------------------------------------------------

export const DRAWER_ID = {
  GANTT_CREATE: "gantt-create",
  GANTT_EDIT: "gantt-edit",
} as const;

type ActiveDrawer = { id: typeof DRAWER_ID.GANTT_CREATE } | { id: typeof DRAWER_ID.GANTT_EDIT; bucketId: number };

export interface DrawerSlice {
  activeDrawer: ActiveDrawer | null;
  openDrawer: (drawer: ActiveDrawer) => void;
  closeDrawer: () => void;
}

export const createDrawerSlice: StateCreator<UIState, [], [], DrawerSlice> = (set) => ({
  activeDrawer: null,
  openDrawer: (drawer) => set({ activeDrawer: drawer }),
  closeDrawer: () => set({ activeDrawer: null }),
});
